module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAEUlEQVR4AWMYBaNgFIwCKAAABBAAAe1TJlIAAAAASUVORK5CYII="